import React from "react";
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";



const leftSidedImageCopyItemCollectionData = [
  {
    description: [
      "This inner-city garden was designed to meet the needs of a young family who like to entertain but still required solutions for storage and off street parking. Key to the design was connecting the two different areas of the lower courtyard with the upper carstand area. A solution was obtained through constructing an intermediate landing with built in seating and a new gas BBQ. An open style steel balustrade allows for safety between the two areas and visually takes full advantage of the depth of the property. All-weather protection provided by retractable awnings to both upper and lower areas ensures year round enjoyment. Sliding doors in the garage help the generous storage recede into the design.",
      "Spotted gum hardwood timber decking extends the internal areas outside and the wrap around steps further connect the spaces by providing an inviting entry to the BBQ area. A large floating timber bench seat is both practical and breaks up the large retaining wall to the upper carport.",
      "A grey and white colour pallete provides a sophisticated look whilst highlighting punctuations of playful colour and contemporary styling to link the children’s play areas with the home.",
    ],
    descriptionContent: (
      <p>
        <span className="line">
          <b>Services Undertaken</b>
          <br />
          Landscape Design
          <br />
          Construction
          <br />
          Ongoing Maintenance
          <br />
          Application to Council
          <br />
          Structural Engineering
        </span>
        <b>Design Features</b>
        <br />
        Contemporary
        <br />
        Family
        <br />
        Entertainer
      </p>
    ),
    image: "../images/projects/roselle-4.jpg",
    title: "Roselle",
  },
];

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/roselle-1.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/roselle-2.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/roselle-3.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/roselle-4.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/roselle-5.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/roselle-6.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/roselle-7.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/roselle-8.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/roselle-9.jpg'
    },
];

const PageRoselle = () => {
  return (
    <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
  )
};

export default PageRoselle;
